// importing axios for network request
import axios from 'axios'

// Get Authentication token
const getUrl = (roomSid, participantSid) => {
    const url = `https://video.twilio.com/v1/Rooms/${roomSid}/Participants/${participantSid}/SubscribeRules`
    return url
}

//Creating config for the axios instance
const createPostConfig = (rules, roomSid, participantSid) => {
    const config = {
        method: 'post',
        url: getUrl(roomSid, participantSid),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        auth: {
            username: 'SK76b7bad9340d48389393e07a1a47e479',
            password: '0baMOPz4WQ1zx6jDNtbdXWt1D1cg7hNt',
        },
        data: rules,
    }

    return config
}

const createGetConfig = (roomSid, participantSid) => {
    const config = {
        method: 'get',
        url: getUrl(roomSid, participantSid),
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
        },
        auth: {
            username: 'SK76b7bad9340d48389393e07a1a47e479',
            password: '0baMOPz4WQ1zx6jDNtbdXWt1D1cg7hNt',
        },
    }

    return config
}

export default function TwilioAxios(rules, roomSid, participantSid) {
    // Created Twilio Axios instance for any subscription rules for audio, video, data
    let instance
    if (rules)
        instance = axios(createPostConfig(rules, roomSid, participantSid))
    else instance = axios(createGetConfig(roomSid, participantSid))
    return instance
}
